
// Currency conversion rates
const CURRENCY_RATES = {
  KES: 1,
  Birr: 21.5, // Ethiopian Birr
  ETB: 21.5, // Alternative code for Ethiopian Birr
  USD: 0.0077 // Example: 1 KES = 0.0077 USD
};

// Currency symbols/formats
const CURRENCY_FORMATS = {
  USD: (val: number) => `$${val}`,
  KES: (val: number) => `KES ${val}`,
  Birr: (val: number) => `${val} Birr`,
  ETB: (val: number) => `${val} Birr`
};

// Format price based on currency
export const formatPrice = (price: number, currency: string): string => {
  // Special case for free (price = 0)
  if (price === 0) {
    return CURRENCY_FORMATS[currency as keyof typeof CURRENCY_FORMATS] 
      ? CURRENCY_FORMATS[currency as keyof typeof CURRENCY_FORMATS](0)
      : `${currency} 0`;
  }
  
  // Get the formatter function for the currency (or use a default)
  const formatter = CURRENCY_FORMATS[currency as keyof typeof CURRENCY_FORMATS] || 
    ((val: number) => `${currency} ${val}`);
  
  // Return the formatted price
  return formatter(Math.round(price));
};
